import React from 'react';
import * as keyset from 'i18n/SettingsLabels';
import i18n from '@yandex-int/i18n';
import { SkillAccess, skillAccesses } from '../../../model/settings';
import { Field } from '../../Form/Form';
import { skillLabels } from './labels';
import { commonAccessDescriptions } from './descriptions';
import { Channel } from '../../../model/skill';
import { Select } from '../../Select/Select';
import { useCurrentAliceApp } from '../../../hooks/useCurrentAliceApp';
import { useSettingsPageContext } from '../../../context/settingsPageContext';

import './SkillAccessField.scss';

const t = i18n(keyset);

interface Props {
    skillAccess?: SkillAccess;
    setSkillAccess: (skillAccess: SkillAccess) => void;
    disabled?: boolean;
    channel: Channel;
}

export const SkillAccessField: React.FC<Props> = ({
    skillAccess = SkillAccess.Public,
    setSkillAccess,
    disabled,
    channel,
}) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const skill = useCurrentAliceApp()!;
    const { isDraft } = useSettingsPageContext();

    const isHiddenAccess = isDraft
        ? skill.draft.skillAccess === SkillAccess.Hidden
        : skill.skillAccess === SkillAccess.Hidden;

    const displayedSkillAccesses = isHiddenAccess
        ? skillAccesses[channel]
        : skillAccesses[channel].filter((access) => access.type !== SkillAccess.Hidden);

    return (
        <Field name="skillAccess" label={skillLabels.skillAccess} description={commonAccessDescriptions[skillAccess]()}>
            <Select
                label={skillLabels.skillAccess}
                namespace="skill_access"
                placeholder={t('skill-access')}
                type="radio"
                value={skillAccess}
                onChange={(value) => {
                    setSkillAccess(value as SkillAccess);
                }}
                disabled={disabled}
                options={displayedSkillAccesses.map(({ type, label }) => ({ value: type, text: label }))}
            />
        </Field>
    );
};
